import React, { Fragment } from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
   
    titleContainer:{
        flexDirection: 'row',
        marginTop: 2,
        marginBottom: 10
    },
    reportTitle:{
        fontSize: 9,
        lineHeight:1.5
    },
  });
  

  

    const InvoiceThankYouMsg = ({invoice}) =>{
        var invoice1 = (JSON.stringify(invoice));
        var invoice2 = JSON.parse(invoice1);
        var invoice3 = JSON.parse(invoice2);
    return(
        <Fragment>
            <View style={styles.titleContainer}>
            {invoice3?.markupdata?.hideBrandingLogo == false?(
            <Text style={styles.reportTitle}>The booking is powered by Holidays Seychelles {'\n'}Emergency number - +248 437 6666 </Text>):(<></>)}
            </View>
     </Fragment>
      );
 
    } 
  
  export default InvoiceThankYouMsg